module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1223.d4928875.png";